import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuthSession } from '@modeling/account';

export const ProtectedRoutes: React.FC = () => {
  const session = useAuthSession();
  const initialized = session.initialized;

  useEffect(() => {
    if (initialized && !session.authenticated) {
      session.login();
    }
  }, [session, initialized]);

  if (!initialized || !session.authenticated) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="正在验证登录状态..." />
      </div>
    );
  }

  return <Outlet />;
};
